module.exports = __webpack_public_path__ + "static/img/vpcs.743153a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vpcs.png
// module id = tTCL
// module chunks = 1